import { activity } from '@loom-js/core';

const isShown = false;
export const cartToggle = activity(isShown);
